import { render } from "./MobileTablet.vue?vue&type=template&id=109b703b"
import script from "./MobileTablet.vue?vue&type=script&lang=js"
export * from "./MobileTablet.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__